import type { ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface SectionHeadProps {
  title: string;
  /** Rechts in de regel: meestal een "Alles"-link, soms niets. */
  action?: ReactNode;
  /** Voor `aria-labelledby` op de sectie eromheen. */
  id?: string;
  className?: string;
}

/**
 * De kop boven een blok op het beginscherm: titel links, actie rechts.
 *
 * Dit is wat het beginscherm van de mockup ritme geeft, en wat het onze niet had. Daar stond één
 * `h1` en daaronder een stapel witte kaarten die allemaal even belangrijk leken: de pushvraag, de
 * snelkoppelingen, de formulieren, de meldingen, de tijdlijn en zelfs de instellingen. Zonder
 * koppen moet je elk blok lezen om te weten wat het is.
 *
 * Twee details die het verschil maken en die je anders kwijtraakt:
 *
 * - De kop staat **plat op de achtergrond**, niet in een kaart. Een kaart zegt "dit is een object";
 *   een kop zegt "hieronder staan objecten". Ze allebei in een kaart zetten maakt het onderscheid
 *   stuk (zie `docs/design/components.md`).
 * - De actie is een **link naast de titel**, niet een knop eronder. Zo blijft de rij één regel hoog
 *   en kost een sectie zes pixels in plaats van veertig — op een telefoonscherm is dat het verschil
 *   tussen drie zichtbare secties en twee.
 */
export function SectionHead({ title, action, id, className }: SectionHeadProps) {
  return (
    <div className={cn('flex items-baseline justify-between gap-inline px-1 pb-2 pt-1', className)}>
      <h2 id={id} className="font-heading text-section font-semibold text-text-primary">
        {title}
      </h2>
      {action ? (
        <span className="shrink-0 font-heading text-support font-medium">{action}</span>
      ) : null}
    </div>
  );
}
